import React from 'react';
import { Button, Row } from 'react-bootstrap';
import useLocalize from '../utils/hooks/useLocalize';

const ErrorMessage = ({ error, close }) => {
  const { localize } = useLocalize();

  return (
    <div title="Error">
      <div className="alert alert-danger">{error}</div>
      <Row className="justify-content-center">
        <Button variant="secondary" className="w-em-8" onClick={close}>
          {localize('error.button.ok')}
        </Button>
      </Row>
    </div>
  );
};

export default ErrorMessage;
